import React from "react";
import { motion } from "framer-motion";
import { BookOpenIcon, FlameIcon, GiftIcon, GlobeIcon, LockIcon } from "lucide-react";
import { images } from "../../data/content";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
const SPOTS_TOTAL = 100;
const SPOTS_LEFT = 7;
const perks = ["One-time payment", "Lifetime digital access", "No monthly fees", "Instant download"];
export function Offer() {
  const filled = (SPOTS_TOTAL - SPOTS_LEFT) / SPOTS_TOTAL * 100;
  return <section id="offer" className="bg-cream px-4 py-16 sm:py-20" data-id="element-181" data-mp="3f3i6h0638fwv">
      <div className="mx-auto max-w-2xl" data-id="element-182" data-mp="3jvic998ua31d">
        <p className="text-center text-sm font-extrabold uppercase tracking-[0.16em] text-teal" data-id="element-183" data-mp="3jwjmjbi16li1">Special launch offer</p>
        <h2 className="mt-3 text-center font-serif text-[2rem] font-extrabold leading-tight text-navy sm:text-5xl" data-id="element-184" data-mp="3nw25w2u7eoir">
          Here’s everything I’ll receive today
        </h2>

        <div className="mt-8 overflow-hidden rounded-[28px] bg-navy text-white shadow-[0_30px_60px_-25px_rgba(11,27,46,0.6)]" data-id="element-185" data-mp="1qf4fgrhncx9">
          <img src={images.main} alt="Everything included in the Rhinoplasty Master Planner" className="block w-full bg-white" data-id="element-186" data-mp="1kjdnhdnilf4l" />

          <div className="px-5 py-8 sm:px-10" data-id="element-187" data-mp="1bkiejtt35qxl">
            <ul className="divide-y divide-white/10" data-id="element-188" data-mp="1blbot4r96ykh">
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-189" data-mp="16m8jrkb9wsci">
                <span className="flex items-center gap-3" data-id="element-190" data-mp="16o1p8wa5h6ix">
                  <BookOpenIcon className="h-6 w-6 shrink-0 text-teal-light" aria-hidden="true" data-id="element-191" data-mp="23aodlslf1nvf" />
                  <span data-id="element-192" data-mp="1zbnxwiy8j1cn">
                    <span className="block font-bold" data-id="element-193" data-mp="1zch49ita7ou9">Rhinoplasty Master Planner™</span>
                    <span className="text-sm text-white/70" data-id="element-194" data-mp="1uhtfrjya2ufo">6 Premium Volumes</span>
                  </span>
                </span>
                <span className="font-bold text-white/80 line-through" data-id="element-195" data-mp="2mzyqkyts1upu">$97</span>
              </li>
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-196" data-mp="2i98mrq101zx9">
                <span className="flex items-center gap-3" data-id="element-197" data-mp="2i75ka6inuebn">
                  <GiftIcon className="h-6 w-6 shrink-0 text-teal-light" aria-hidden="true" data-id="element-198" data-mp="316ij2k5nwmgi" />
                  <span data-id="element-199" data-mp="364tuv0fip71d">
                    <span className="block font-bold" data-id="element-200" data-mp="36429eifmwpot">5 Exclusive Bonuses</span>
                    <span className="text-sm text-white/70" data-id="element-201" data-mp="2sc47arkcbu25">Guides, checklists & templates</span>
                  </span>
                </span>
                <span className="font-bold text-white/80 line-through" data-id="element-202" data-mp="2wce9ru8xc2c9">$127</span>
              </li>
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-203" data-mp="2ihc85jb40z59">
                <span className="font-bold uppercase tracking-wider" data-id="element-204" data-mp="2nfdpnzsw0qem">Total value</span>
                <span className="text-xl font-extrabold text-red-400 line-through" data-id="element-205" data-mp="29fmdm4lxlk39">$224</span>
              </li>
            </ul>

            <div className="mt-6 text-center" data-id="element-206" data-mp="2dhzcc929ghqj">
              <p className="text-sm font-bold uppercase tracking-[0.16em] text-teal-light" data-id="element-207" data-mp="7moiu38lghfo">Today I get everything for</p>
              <p className="mt-1 font-serif text-7xl font-black leading-none text-white sm:text-8xl" data-id="element-208" data-mp="bn8c2vq1r0wj">
                <span className="align-top text-3xl sm:text-4xl" data-id="element-209" data-mp="1w73qyh9lefxo">$</span>27
              </p>
              <p className="mt-2 text-sm font-semibold text-white/80" data-id="element-210" data-mp="1s6a1vkkeyv37">Only USD $27 · one-time payment</p>
            </div>

            <div className="mt-5 flex items-start gap-3 rounded-2xl bg-navy-700 px-4 py-3 text-left" data-id="element-211" data-mp="25ygkddb1he5t">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal-light" aria-hidden="true" data-id="element-212" data-mp="213kh1h0cr4de" />
              <p className="text-sm leading-snug text-white/90" data-id="element-213" data-mp="2fwnzdqlrpm56">
                <strong className="text-white" data-id="element-214" data-mp="2auou2b6gwf5l">Automatic currency conversion:</strong> the price is shown and charged in your local currency at checkout.
              </p>
            </div>

            <ul className="mt-5 grid grid-cols-2 gap-2" data-id="element-215" data-mp="2jvwogi5v4vue">
              {perks.map(p => <li key={p} className="rounded-xl bg-white/5 px-3 py-2.5 text-center text-[13px] font-semibold text-white/90" data-id="element-216" data-mp="ugf6vkdyowgc">
                  {p}
                </li>)}
            </ul>

            <div className="mt-7 rounded-2xl bg-white p-4 text-navy" data-id="element-217" data-mp="rxk8ni2csntj">
              <p className="flex items-center justify-center gap-2 text-center text-[15px] font-extrabold" data-id="element-218" data-mp="vy41wajt37ae">
                <FlameIcon className="h-5 w-5 shrink-0 text-red-600" aria-hidden="true" data-id="element-219" data-mp="10wyuu5bhmc88" />
                Only {SPOTS_LEFT} spots left at the promotional price!
              </p>
              <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-cream-dark" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-220" data-mp="15u7c83otac8f">
                <motion.div className="h-full rounded-full bg-red-600" initial={{
                width: "0%"
              }} whileInView={{
                width: `${filled}%`
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.9,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-221" data-mp="mxz4mt8btp9y" />
              </div>
              <p className="mt-2 flex justify-between text-xs font-semibold text-ink-muted" data-id="element-222" data-mp="3j171yau4szt9">
                <span data-id="element-223" data-mp="3e4ydu7xyhw9y">{Math.round(filled)}% claimed</span>
                <span data-id="element-224" data-mp="394ap5sx79riw">{SPOTS_LEFT} spots remaining</span>
              </p>
            </div>

            <CtaButton label="Yes — I want the Rhinoplasty Master Planner™" note="One-time payment of $27 · Instant Access · 7-Day Guarantee" noteTone="light" className="mt-7" data-id="element-225" data-mp="346iooaihox33" />
            <Countdown tone="light" data-id="element-226" data-mp="2vce3o7q1efvh" />

            <p className="mt-6 flex items-center justify-center gap-2 text-xs font-medium text-white/60" data-id="element-227" data-mp="2qeci9g5524gu">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-228" data-mp="2lg1977mo3xzo" />
              Secure checkout · Your data is protected
            </p>
          </div>
        </div>

        <p className="mt-6 text-center text-base leading-relaxed text-ink-muted" data-id="element-229" data-mp="2gi975ksb6vhr">
          That’s less than the cost of a professional reference book, yet gives me a reusable planning system I can return to whenever I study a new case.
        </p>
      </div>
    </section>;
}